import { Application } from "@hotwired/stimulus"

const application = Application.start()

window.Stimulus = application

export { application }
